<template>
  <div class="chart-box">
    <div class="echart-dom" :id="id" ></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  data() {
    return {
      lineChart: '',
      dataList: [
        {
          time: '2024-02-05 12:00',
          value: 3.44
        },
        {
          time: '2024-02-05 13:00',
          value: 3.14
        },
        {
          time: '2024-02-05 14:00',
          value: 4.74
        },
        {
          time: '2024-02-05 15:00',
          value: 2.66
        },
        {
          time: '2024-02-05 16:00',
          value: 3.14
        },
        {
          time: '2024-02-05 17:00',
          value: 5.55
        },
        {
          time: '2024-02-05 18:00',
          value: 3.44
        },
      ]
    }
  },
  props: {
    id: [String, Number],
    showChart: Boolean,
    chartData: Array,
    color: String
  },
  watch: {
    color() {
      if (this.lineChart) {
        this.lineChart.setOption({
          series: [{
            lineStyle: {
              color: this.color == 'red' ? '#FF5C51' : '#38B781',
            }
          }]
        })
      }
    }
  },
  mounted() {
    if (this.id) {
      setTimeout(() => {
        this.init(this.dataList)
      }, 500)
    }
  },
  methods: {
    init(data) {
      var lineChart = echarts.init(document.getElementById(this.id));
      let xchart = data.map(v => {
        return v.time
      })
      let ydata = data.map(v => {
        return v.value
      })
      const option = {
        title: {
          show: false
        },
        grid: {
          top: '15',
          left: '30',
          right: '30',
          bottom: '0',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xchart,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        tooltip: {
          show: false
        },
        series: [{
          data: ydata,
          type: 'line',
          showSymbol: false,
          color: this.color == 'red' ? '#FF5C51' : '#38B781',
        }]
      };

      lineChart.setOption(option);
      this.lineChart = lineChart
    }
  }
}
</script>